<template>
  <div>
    <v-tabs slider-color="#ff721c">
      <v-tab
        v-for="tab in tabs"
        :key="tab.to"
        class="fs-18"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'"
        :to="tab.to"
      >{{tab.title}}</v-tab>
    </v-tabs>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "IndicationsTabs",
  data: () => ({

  }),
  computed:{
    tabs() {
      return [
      {
        title: this.$t('pages.indicationsEnter.transfer'),
        to: "/indications/enter"
      },
      {
        title: this.$t('pages.indicationsEnter.history'),
        to: "/indications/history"
      }
    ]
    },
    ...mapGetters("locale",["currentLocale"]),
  }
};
</script>

<style lang="scss" scoped>
$orange-gradient-horizontal: linear-gradient(to right, #ff6600, #ff500b);

a.v-tab {
  padding-left: 30px;
  padding-right: 30px;
  @media screen and (max-width: 768px) {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }
}

a.v-tab.v-tab--active {
  color: white;
  background: $orange-gradient-horizontal;
}

.v-tabs {
  border-bottom: solid 1px;
}
</style>
